import { ModalWrapper } from "../../templates/ModalWrapper"

export const DocumentPreviewModal = ({
  fileUrl,
  onClose,
}: {
  fileUrl: string
  onClose: () => void
}) => {
  return (
    <ModalWrapper onClose={() => onClose()}>
      <div style={{ height: "90vh", width: "80vw" }}>
        <iframe src={fileUrl} width="100%" height="100%">
          This browser does not support PDFs. Please download the PDF to view it:
          <a href={fileUrl}>Download PDF</a>
        </iframe>
      </div>
    </ModalWrapper>
  )
}
